import styled, { css } from 'styled-components'
import { TooltipProps } from '@elamajs/ui-kit'

export const Main = styled.div`
  * {
    font-family: Navigo, Arial, Helvetica, sans-serif;
  }

  display: flex;
  column-gap: 35px;

  & > span {
    z-index: 3;
  }

  @media (max-width: 1279px) {
    flex-direction: column;
    row-gap: 40px;
  }

  @media (max-width: 999px) {
    row-gap: 20px;
  }
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  flex: 1 0 880px;

  @media (max-width: 1279px) {
    flex: 1;
  }
`

export const Row = styled.div<{ $raiseTitleOnMobile?: boolean }>`
  padding: 40px;
  padding-right: 0;
  position: relative;

  display: flex;
  flex-direction: column;
  row-gap: 20px;

  border-radius: 20px;
  background: ${({ theme }) => theme.palette.white};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 20px;
    height: 100%;
    width: 100vw;
    background: ${({ theme }) => theme.palette.white};
  }

  @media (max-width: 999px) {
    padding: 4rem 2rem;
    margin-left: -20px;
    margin-right: -20px;

    border-radius: 0;

    &::before {
      content: none;
    }
  }

  @media (max-width: 767px) {
    padding: 4rem 1.5rem;

    &::before {
      content: '';
      left: -25vw;
      width: 200vw;
    }
  }

  & > div,
  & > h3,
  & > span {
    z-index: 1;
  }

  ${({ $raiseTitleOnMobile }) =>
    $raiseTitleOnMobile &&
    css`
      @media (max-width: 767px) {
        & > h3 {
          z-index: 2;
        }
      }
    `}
`

type StyledContainerProps = {
  height?: number
}

export const FlexContainer = styled.div<StyledContainerProps>`
  display: flex;
  gap: 20px;

  @media (max-width: 999px) {
    flex-direction: column;
  }

  height: 100%;
  ${({ height }) =>
    height &&
    css`
      min-height: ${height}px;
    `}
`

export const Title = styled.h3`
  margin: 0;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;

  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
`

export const Underline = styled.span`
  font: inherit;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDEwMCA0IiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTEgM0MxOS45MzUxIDEuNDkwNzUgNjYuMDQ0MiAtMC42MjIxOTMgOTkgMyIgc3Ryb2tlPSIjRkZERDMzIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4=');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 0 1.1em;
`

export const Subtitle = styled.span`
  margin-top: -20px;
  margin-bottom: 14px;
  color: ${({ theme }) => theme.palette.black[20]};

  @media (max-width: 767px) {
    margin-bottom: 0;
  }
`

export const Tooltip = styled.div<TooltipProps>`
  color: #667399;

  ~ div {
    z-index: 2;
    max-width: 29.3rem;

    & > div {
      display: flex;
      flex-direction: column;
      row-gap: 20px;

      font-size: 12px;
      line-height: 18px;
      font-weight: 400;

      color: ${({ theme }) => theme.palette.black[50]};
    }
  }
`

export const TooltipTitle = styled.div<TooltipProps>`
  color: #292e3d;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 2rem;
  height: 2rem;

  ~ div {
    z-index: 2;
    max-width: 29.3rem;

    & > div {
      display: flex;
      flex-direction: column;
      row-gap: 2rem;

      font-size: 1.2rem;
      line-height: 1.8rem;
      font-weight: 400;

      color: ${({ theme }) => theme.palette.black[50]};
    }
  }
`
